import { Directive, ElementRef, HostListener, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[appLowercase]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LowercasePipe),
      multi: true,
    },
  ],
})
export class LowercasePipe implements ControlValueAccessor {
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: any): void {
    const lower = value ? String(value).toLowerCase() : '';
    this.el.nativeElement.value = lower;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }

  @HostListener('input', ['$event.target.value'])
  _handleInput(value: string) {
    const lower = value.toLowerCase();
    this.el.nativeElement.value = lower;
    this.onChange(lower);
  }

  @HostListener('blur')
  _handleBlur() {
    this.onTouched();
  }
}
